import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["demo", "stepOne", "stepTwo", "continue"]
  static values = { cancelPath: String, continuePath: String }

  enable() {
    this.continueTarget.disabled = false
  }

  next(event) {
    event.preventDefault()

    if (this.demo) {
      this.continue()
    } else {
      this.stepOneTarget.hidden = true
      this.stepTwoTarget.hidden = false
    }
  }

  continue() {
    if (this.demo) {
      Turbo.visit(this.continuePathValue + "?demo=true")
    } else {
      Turbo.visit(this.continuePathValue + "?confirmed=true")
    }
  }

  cancel(event) {
    event.preventDefault()
    Turbo.visit(this.cancelPathValue)
  }

  get demo() {
    return this.demoTargets.find(radio => radio.checked).value == "Yes"
  }
}
